import { useMemo } from "react";
import { LaserScanParameterModel } from "~/pages/copilotMessage/types/copilot";
import { getOrdinalSuffix } from "~/helpers/number";
import { LidarDataSummaryForVisualizationMapped } from "../types/getLiDARDataVisualizationSummariesForLastSpecificHeats";

export const useLiDARHeatData = (
  zoneMappedLiDARMeasurementSummaries: LidarDataSummaryForVisualizationMapped[] = [],
  lidarParams: LaserScanParameterModel,
  options?: {
    textMapper?: (
      heatNumber: number,
      counter: Record<string, number>,
    ) => string;
  },
) => {
  const sortedRawData = useMemo(() => {
    return zoneMappedLiDARMeasurementSummaries.sort((a, b) =>
      a.heatNumber < b.heatNumber ? -1 : 1,
    ) as LidarDataSummaryForVisualizationMapped[];
  }, [zoneMappedLiDARMeasurementSummaries]);

  const defaultIndex = useMemo(() => {
    return sortedRawData.findIndex(
      (x) =>
        x.liDARMeasurementsCloudFileKey ===
        lidarParams.LiDARMeasurementsCloudFileKey,
    );
  }, [sortedRawData, lidarParams]);

  const heatTexts = useMemo(() => {
    const counter: Record<string, number> = {};

    return sortedRawData
      .map((x) => {
        if (
          sortedRawData.filter((y) => y.heatNumber === x.heatNumber).length > 1
        ) {
          counter[x.heatNumber] = (counter[x.heatNumber] || 0) + 1;
          return options?.textMapper
            ? options?.textMapper(x.heatNumber, counter)
            : `${x.heatNumber} ${counter[x.heatNumber]}${getOrdinalSuffix(
                counter[x.heatNumber],
              )}`;
        } else {
          return options?.textMapper
            ? options?.textMapper(x.heatNumber, counter)
            : x.heatNumber.toString();
        }
      })
      .filter((_, index) => index <= defaultIndex);
  }, [sortedRawData, options, defaultIndex]);

  return { sortedRawData, heatTexts, defaultIndex };
};
